import React, {
  useEffect,
  useState,
} from "react";

import AppModal from "./AppModal";

const MeetingModal = ({
  show,
  setShow,
  editData,
}) => {

  const [formData, setFormData] =
    useState({
      title: "",
      date: "",
      time: "",
      host: "",
      members: "",
      mode: "",
      status: "",
      meeting_link: "",
      location: "",
      agenda: "",
    });

  // Edit Data Fill
  useEffect(() => {

    if (editData) {

      setFormData({
        title:
          editData.title || "",
        date:
          editData.date || "",
        time:
          editData.time || "",
        host:
          editData.host || "",
        members:
          editData.members || "",
        mode:
          editData.mode || "",
        status:
          editData.status || "",
        meeting_link:
          editData.meeting_link || "",
        location:
          editData.location || "",
        agenda:
          editData.agenda || "",
      });

    } else {

      setFormData({
        title: "",
        date: "",
        time: "",
        host: "",
        members: "",
        mode: "",
        status: "",
        meeting_link: "",
        location: "",
        agenda: "",
      });

    }

  }, [editData, show]);

  // Input Change
  const handleChange = (e) => {

    const { name, value } =
      e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Submit
  const handleSubmit = () => {

    console.log(formData);

    setShow(false);
  };

  return (
    <AppModal
      show={show}
      setShow={setShow}
      title={
        editData
          ? "Edit Meeting"
          : "Add Meeting"
      }
      size="modal-lg"
      footer={
        <>
          <button
            className="btn btn-danger"
            onClick={() =>
              setShow(false)
            }
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            {editData
              ? "Update Meeting"
              : "Save Meeting"}
          </button>
        </>
      }
    >

      <div className="row">

        {/* Meeting Title */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Meeting Title
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter meeting title"
            name="title"
            value={formData.title}
            onChange={handleChange}
          />

        </div>

        {/* Host */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Host Name
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter host name"
            name="host"
            value={formData.host}
            onChange={handleChange}
          />

        </div>

        {/* Date */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Meeting Date
          </label>

          <input
            type="date"
            className="form-control"
            name="date"
            value={formData.date}
            onChange={handleChange}
          />

        </div>

        {/* Time */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Meeting Time
          </label>

          <input
            type="time"
            className="form-control"
            name="time"
            value={formData.time}
            onChange={handleChange}
          />

        </div>

        {/* Members */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Total Members
          </label>

          <input
            type="number"
            className="form-control"
            placeholder="Enter total members"
            name="members"
            value={formData.members}
            onChange={handleChange}
          />

        </div>

        {/* Mode */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Meeting Mode
          </label>

          <select
            className="form-select"
            name="mode"
            value={formData.mode}
            onChange={handleChange}
          >
            <option value="">
              Select Mode
            </option>

            <option value="Online">
              Online
            </option>

            <option value="Offline">
              Offline
            </option>

          </select>

        </div>

        {/* Status */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Status
          </label>

          <select
            className="form-select"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="">
              Select Status
            </option>

            <option value="Upcoming">
              Upcoming
            </option>

            <option value="Completed">
              Completed
            </option>

            <option value="Cancelled">
              Cancelled
            </option>

          </select>

        </div>

        {/* Meeting Link */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Meeting Link
          </label>

          <input
            type="url"
            className="form-control"
            placeholder="Enter meeting link"
            name="meeting_link"
            value={formData.meeting_link}
            onChange={handleChange}
          />

        </div>

        {/* Location */}
        <div className="col-md-12 mb-3">

          <label className="form-label">
            Meeting Location
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter meeting location"
            name="location"
            value={formData.location}
            onChange={handleChange}
          />

        </div>

        {/* Agenda */}
        <div className="col-md-12 mb-3">

          <label className="form-label">
            Meeting Agenda
          </label>

          <textarea
            rows="4"
            className="form-control"
            placeholder="Write meeting agenda..."
            name="agenda"
            value={formData.agenda}
            onChange={handleChange}
          ></textarea>

        </div>

      </div>

    </AppModal>
  );
};

export default MeetingModal;